module.exports = __webpack_public_path__ + "img/outlook.d895a4e2.jpeg";